import { OILSTEEL_BORDER_RADIUS, OILSTEEL_BOX_SHADOW, OILSTEEL_COLORS, OILSTEEL_FONTS, OILSTEEL_LAYOUT, OILSTEEL_SPACING, } from './oilsteelThemeConf';
import { createTheme } from '@material-ui/core/styles';
import { border, toCssValue } from '../themeUtils';
const oilsteelThemeConfiguration = {
    color: {
        primary: {
            lightest: OILSTEEL_COLORS.primary.lightest,
            light: OILSTEEL_COLORS.primary.light,
            main: OILSTEEL_COLORS.primary.main,
            dark: OILSTEEL_COLORS.primary.dark,
            darkest: OILSTEEL_COLORS.primary.darkest,
        },
        brand: {
            lightest: OILSTEEL_COLORS.brand.lightest,
            light: OILSTEEL_COLORS.brand.light,
            main: OILSTEEL_COLORS.brand.main,
            dark: OILSTEEL_COLORS.brand.dark,
            darkest: OILSTEEL_COLORS.brand.darkest,
        },
        success: {
            light: OILSTEEL_COLORS.success.light,
            main: OILSTEEL_COLORS.success.main,
            dark: OILSTEEL_COLORS.success.dark,
        },
        error: {
            lightest: OILSTEEL_COLORS.error.lightest,
            light: OILSTEEL_COLORS.error.light,
            main: OILSTEEL_COLORS.error.main,
            dark: OILSTEEL_COLORS.error.dark,
        },
        warning: {
            lightest: OILSTEEL_COLORS.warning.lightest,
            light: OILSTEEL_COLORS.warning.light,
            main: OILSTEEL_COLORS.warning.main,
        },
        grey: {
            lightest: OILSTEEL_COLORS.grey.lightest,
            light: OILSTEEL_COLORS.grey.light,
            default: OILSTEEL_COLORS.grey.default,
            dark: OILSTEEL_COLORS.grey.dark,
            darkest: OILSTEEL_COLORS.grey.darkest,
        },
        input: {
            placeholder: OILSTEEL_COLORS.grey.default,
            border: OILSTEEL_COLORS.grey.default,
        },
        background: {
            body: OILSTEEL_COLORS.background.body,
            light: OILSTEEL_COLORS.background.light,
            dark: OILSTEEL_COLORS.background.dark,
        },
        font: {
            dark: OILSTEEL_COLORS.font.dark,
            light: OILSTEEL_COLORS.font.light,
        },
        common: {
            contentHover: OILSTEEL_COLORS.common.contentHover,
        },
    },
    font: {
        family: OILSTEEL_FONTS.family,
        size: {
            small: OILSTEEL_FONTS.size.small,
            mediumSmall: OILSTEEL_FONTS.size.mediumSmall,
            medium: OILSTEEL_FONTS.size.medium,
            mediumBig: OILSTEEL_FONTS.size.mediumBig,
            big: OILSTEEL_FONTS.size.big,
            caption: OILSTEEL_FONTS.size.caption,
            title: OILSTEEL_FONTS.size.title,
            heading: OILSTEEL_FONTS.size.heading,
        },
        lineHeight: {
            small: OILSTEEL_FONTS.lineHeight.small,
            mediumSmall: OILSTEEL_FONTS.lineHeight.mediumSmall,
            medium: OILSTEEL_FONTS.lineHeight.medium,
            mediumBig: OILSTEEL_FONTS.lineHeight.mediumBig,
            big: OILSTEEL_FONTS.lineHeight.big,
        },
        weight: {
            light: OILSTEEL_FONTS.weight.light,
            normal: OILSTEEL_FONTS.weight.normal,
            bold: OILSTEEL_FONTS.weight.bold,
        },
    },
    common: {
        borderRadius: {
            low: OILSTEEL_BORDER_RADIUS.low,
            default: OILSTEEL_BORDER_RADIUS.default,
            high: OILSTEEL_BORDER_RADIUS.high,
            onlyTop: OILSTEEL_BORDER_RADIUS.onlyTop,
            onlyRight: OILSTEEL_BORDER_RADIUS.onlyRight,
        },
        shadow: {
            light: OILSTEEL_BOX_SHADOW.light,
            default: OILSTEEL_BOX_SHADOW.default,
            dark: OILSTEEL_BOX_SHADOW.dark,
        },
    },
    space: {
        layout: {
            fullWidth: OILSTEEL_SPACING.layout.fullWidth,
            partialWidth: OILSTEEL_SPACING.layout.partialWidth,
        },
        margin: {
            smallest: OILSTEEL_SPACING.margin.smallest,
            small: OILSTEEL_SPACING.margin.small,
            default: OILSTEEL_SPACING.margin.default,
            large: OILSTEEL_SPACING.margin.large,
            largest: OILSTEEL_SPACING.margin.largest,
            horizontalDefault: OILSTEEL_SPACING.margin.horizontalDefault,
            verticalDefault: OILSTEEL_SPACING.margin.verticalDefault,
        },
        padding: {
            smallest: OILSTEEL_SPACING.padding.smallest,
            small: OILSTEEL_SPACING.padding.small,
            default: OILSTEEL_SPACING.padding.default,
            large: OILSTEEL_SPACING.padding.large,
            largest: OILSTEEL_SPACING.padding.largest,
            horizontalDefault: OILSTEEL_SPACING.padding.horizontalDefault,
            verticalDefault: OILSTEEL_SPACING.padding.verticalDefault,
        },
    },
    layout: {
        width: {
            full: OILSTEEL_LAYOUT.width.full,
            partial: OILSTEEL_LAYOUT.width.partial,
        },
        sidebar: {
            full: OILSTEEL_LAYOUT.sidebar.full,
        },
        header: {
            topBar: OILSTEEL_LAYOUT.header.topBar,
            menu: OILSTEEL_LAYOUT.header.menu,
        },
    },
    components: {
        table: {
            header: {
                background: OILSTEEL_COLORS.primary.main,
                color: OILSTEEL_COLORS.font.dark,
            },
            headerSecondary: {
                background: OILSTEEL_COLORS.brand.main,
                color: OILSTEEL_COLORS.font.light,
            },
            th: {
                background: OILSTEEL_COLORS.background.light,
                color: OILSTEEL_COLORS.font.dark,
            },
            row: {
                hover: OILSTEEL_COLORS.common.contentHover,
            },
        },
        link: {
            colors: {
                normal: OILSTEEL_COLORS.primary.main,
                hover: OILSTEEL_COLORS.primary.light,
            },
        },
        tabs: {
            indicator: OILSTEEL_COLORS.primary.main,
            background: OILSTEEL_COLORS.background.light,
            color: OILSTEEL_COLORS.font.dark,
        },
        header: {
            colors: {
                background: OILSTEEL_COLORS.brand.main,
                text: OILSTEEL_COLORS.font.light,
                menuIcon: OILSTEEL_COLORS.font.light,
            },
        },
        menu: {
            colors: {
                background: OILSTEEL_COLORS.background.light,
                text: OILSTEEL_COLORS.font.dark,
                selected: OILSTEEL_COLORS.primary.main,
            },
        },
        userMenu: {
            colors: {
                headerBackground: OILSTEEL_COLORS.brand.main,
                headerText: OILSTEEL_COLORS.font.light,
                buttonBackground: OILSTEEL_COLORS.background.light,
                buttonText: OILSTEEL_COLORS.font.dark,
                buttonBackgroundHover: OILSTEEL_COLORS.primary.main,
                triggerBackground: OILSTEEL_COLORS.background.light,
                triggerText: OILSTEEL_COLORS.primary.main,
                userIconBackground: OILSTEEL_COLORS.primary.main,
                userIconText: OILSTEEL_COLORS.font.light,
            },
        },
        listItem: {
            backgroundHover: OILSTEEL_COLORS.background.light,
            backgroundSelected: OILSTEEL_COLORS.primary.main,
            textHover: OILSTEEL_COLORS.font.dark,
            textSelected: OILSTEEL_COLORS.font.light,
        },
        sidebar: {
            colors: {
                itemSelected: OILSTEEL_COLORS.primary.main,
                border: OILSTEEL_COLORS.primary.main,
            },
        },
        passwordSuggestionBox: {
            container: {
                background: OILSTEEL_COLORS.background.light,
                text: OILSTEEL_COLORS.font.dark,
            },
            arrow: {
                background: OILSTEEL_COLORS.background.light,
            },
            rule: {
                iconSuccess: OILSTEEL_COLORS.success.main,
                iconError: OILSTEEL_COLORS.error.main,
                text: OILSTEEL_COLORS.font.dark,
            },
        },
        logoutButton: {
            background: OILSTEEL_COLORS.grey.lightest,
            backgroundHover: OILSTEEL_COLORS.grey.light,
            text: OILSTEEL_COLORS.font.dark,
        },
    },
};
export function createMyTheme(options) {
    return createTheme({
        palette: {
            primary: {
                light: OILSTEEL_COLORS.primary.light,
                main: OILSTEEL_COLORS.primary.main,
                dark: OILSTEEL_COLORS.primary.dark,
            },
            secondary: {
                light: OILSTEEL_COLORS.brand.light,
                main: OILSTEEL_COLORS.brand.main,
                dark: OILSTEEL_COLORS.brand.dark,
            },
            text: {
                primary: OILSTEEL_COLORS.font.dark,
                secondary: OILSTEEL_COLORS.font.light,
            },
        },
        typography: {
            fontFamily: OILSTEEL_FONTS.family,
            h5: {
                fontSize: '1.25rem',
                lineHeight: '1.5',
            },
            subtitle1: {
                lineHeight: '1.25',
            },
            body1: {
                color: '#4a4a4a',
            },
            caption: {
                color: '#333',
                fontSize: '0.625rem',
            },
            h4: {
                fontSize: '1.5rem',
                fontWeight: 500,
                color: 'black',
            },
        },
        overrides: {
            MuiAutocomplete: {
                noOptions: {
                    color: OILSTEEL_COLORS.font.dark,
                    fontSize: OILSTEEL_FONTS.size.medium,
                },
            },
            MuiInput: {
                underline: {
                    '&:after, &:before': {
                        borderBottom: border('currentColor'),
                    },
                    '&:hover:not($disabled):not($focused):not($error):before': {
                        borderBottomColor: 'currentColor',
                    },
                },
            },
            MuiFormHelperText: {
                root: {
                    marginTop: 2,
                    fontSize: '0.70rem',
                    lineHeight: '0.9em',
                },
            },
            MuiFormLabel: {
                root: {
                    color: OILSTEEL_COLORS.grey.light,
                    '&$disabled': {
                        color: OILSTEEL_COLORS.font.dark,
                    },
                    '&$focused': {
                        color: OILSTEEL_COLORS.font.dark,
                    },
                },
            },
            MuiInputLabel: {
                formControl: {
                    color: OILSTEEL_COLORS.font.dark,
                },
            },
            MuiStepLabel: {
                root: {
                    textTransform: 'uppercase',
                },
                label: {
                    color: OILSTEEL_COLORS.font.dark,
                },
                completed: {
                    '&:hover': {
                        cursor: 'pointer',
                        textDecoration: 'underline',
                    },
                },
                active: {
                    fontWeight: `${OILSTEEL_FONTS.weight.bold} !important`,
                },
                '&$disabled': {
                    color: OILSTEEL_COLORS.grey.light,
                },
            },
            MuiStepIcon: {
                root: {
                    '& text': {
                        fill: OILSTEEL_COLORS.font.light,
                        fontSize: OILSTEEL_FONTS.size.mediumSmall,
                        fontWeight: OILSTEEL_FONTS.weight.bold,
                    },
                },
                completed: {
                    color: `${OILSTEEL_COLORS.primary.main} !important`,
                },
                active: {
                    color: `${OILSTEEL_COLORS.primary.main} !important`,
                },
            },
            MuiInputBase: {
                input: {
                    padding: toCssValue([7, 0, 2]),
                    fontSize: OILSTEEL_FONTS.size.mediumBig,
                },
            },
            MuiRadio: {
                root: {
                    color: OILSTEEL_COLORS.font.dark,
                },
            },
            MuiSelect: {
                select: {
                    padding: toCssValue([7, 0, 6]),
                },
            },
        },
        ...options,
    });
}
export const oilsteelTheme = createMyTheme(oilsteelThemeConfiguration);
//# sourceMappingURL=oilsteelTheme.js.map